const collections = ['resource_pools', 'spaces', 'sessions', 'node_history', 'node_pools', 'tenant_clusters']

export async function loadNodeAllocationSources(axios, query, options = {}) {
    const rpid = Number(query.rpid)
    const hasPool = query.rpid !== null && query.rpid !== undefined && Number.isInteger(rpid) && rpid > 0
    if (!options.admin && !hasPool) throw new Error('A resource-pool ID from the URL is required.')

    const url = options.admin ? '/admin/node_allocation' : `/resource_pools/${rpid}/node_allocation`
    const params = { start_time: query.start_time, end_time: query.end_time }
    if (options.admin && hasPool) params.rpid = rpid
    if (options.sid !== null && options.sid !== undefined) params.sid = options.sid
    // A selected pool is shown with the pools beneath it: the backend then
    // returns the descendant pool metadata and the sessions they were billed to.
    // Global admin (no rpid) keeps its original all-pool scope.
    if (options.includeDescendants && hasPool) params.include_descendants = true

    const { data } = await axios.get(url, { params })
    if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('The allocation endpoint did not return a snapshot object.')
    for (const collection of collections) {
        if (!Array.isArray(data[collection])) throw new Error(`The allocation response is missing its ${collection} array.`)
    }

    return {
        snapshot: {
            sessions: data.sessions,
            node_history: data.node_history,
            node_pools: data.node_pools,
            tenant_clusters: data.tenant_clusters,
            spaces: data.spaces,
            resource_pools: data.resource_pools
        },
        spaces: data.spaces,
        sources: [
            {
                key: 'node_allocation',
                label: options.admin ? 'Admin allocation snapshot' : `Resource pool ${rpid} allocation snapshot`,
                url,
                status: 'loaded',
                count: data.sessions.length,
                message: `One batched response: ${data.spaces.length} spaces, ${data.node_history.length} node lifetimes and ${data.node_pools.length} node pools.`
            }
        ],
        limitations: [
            'Capacity is the last metadata recorded for each node lifetime. Worker placement is the first recorded worker; pod moves and historical capacity updates cannot be reconstructed from these records.'
        ],
        sessionsAvailable: true,
        sessionCount: data.sessions.length
    }
}
